import React from 'react';
import { Table, Badge } from 'react-bootstrap';

/**
 * TenantAuditLogTable
 * - Read-only audit visibility for tenant admins
 * - Tenant-scoped (backend enforced)
 * - Shows who did what, when, and on which project
 */
const TenantAuditLogTable = ({ logs = [] }) => {
  const renderActionBadge = (action) => {
    if (!action) return <Badge bg="secondary">unknown</Badge>;

    if (action.includes('created')) return <Badge bg="success">{action}</Badge>;
    if (action.includes('approved')) return <Badge bg="primary">{action}</Badge>;
    if (action.includes('rejected')) return <Badge bg="danger">{action}</Badge>;
    if (action.includes('updated')) return <Badge bg="warning" text="dark">{action}</Badge>;
    if (action.includes('status')) return <Badge bg="info">{action}</Badge>;

    return <Badge bg="secondary">{action}</Badge>;
  };

  const renderDetails = (details) => {
    if (!details) return '-';
    try {
      return typeof details === 'string'
        ? details
        : JSON.stringify(details);
    } catch {
      return '-';
    }
  };

  return (
    <>
      <Table bordered hover responsive size="sm">
        <thead className="table-light">
          <tr>
            <th scope="col" style={{ width: 160 }}>Timestamp</th>
            <th scope="col" style={{ width: 100 }}>User ID</th>
            <th scope="col" style={{ width: 220 }}>Action</th>
            <th scope="col" style={{ width: 100 }}>Project</th>
            <th>Details</th>
          </tr>
        </thead>

        <tbody>
          {logs.length === 0 && (
            <tr>
              <td colSpan={5} className="text-center text-muted">
                No activity recorded yet.
              </td>
            </tr>
          )}

          {logs.map((log) => (
            <tr key={log.id}>
              <td>
                {log.timestamp
                  ? new Date(log.timestamp).toLocaleString()
                  : '-'}
              </td>
              <td>{log.user_id ?? '-'}</td>
              <td>{renderActionBadge(log.action)}</td>
              <td>{log.project_id ?? '-'}</td>
              <td className="text-break">{renderDetails(log.details)}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </>
  );
};

export default TenantAuditLogTable;
